import { getCookie } from '@/utils/index.js';
import dayjs from 'dayjs';
import dayjsUTC from 'dayjs/plugin/utc';
import dayjsTimezone from 'dayjs/plugin/timezone';
import dayjsRelativeTime from 'dayjs/plugin/relativeTime';
dayjs.extend(dayjsUTC);
dayjs.extend(dayjsTimezone);
dayjs.extend(dayjsRelativeTime);

const defaultValue = '-';
const timezone = getCookie("setTimeZone") || dayjs.tz.guess();

export function titleFilter(value, options = {}){
    if(!value) return defaultValue;
    if(value === 'webui') return 'WebUI';

    value = value.toString();
    if(!options.noCapitalize) value = value[0].toUpperCase() + value.slice(1);

    if(value === 'Wifi') return 'WiFi';

    if (value.match(/^([\d][g])$/)) {
        return value.toUpperCase();
    }

    const acronyms = ['cli', 'gps', 'imei', 'ip', 'iccid', 'imsi', 'lac', 'mac', 'mnc', 'sim', 'wan', 'mcc', ' oc', 'pin', 'wlan', 'rscp', 'ecio', 'rsrp', 'sinr', 'rsrq', 'ddns', 'ssid', 'sms', 'tcp', 'vpn'];
    acronyms.forEach(item => {
        if(item === 'ip'){
            if (value.toLowerCase().match(/ip\b/)){
                value = value.replace('ip', 'IP');
            }
        }
        else if (item === 'cli'){
            if (value.toLowerCase().match(/cli\b/)){
                value = value.replace('cli', 'CLI');
            }
        }
        else if (value.toLowerCase().includes(item)) {
            const regex = new RegExp(item, 'ig');
            value = value.replace(regex, item.toUpperCase());
        }
    });

    if(options.keepUnderscore) return value;
    return value.replace(/_/g, " ");
}

export function capitalize(value) {
    if (!value) return defaultValue;
    return value[0].toUpperCase() + value.slice(1);
}

export function toLocalTime(value, options={}){
    let defaultFormat;
    let isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
    if(isSafari) {
        defaultFormat = options.format ? options.format?.replace(/-/g,'/') : 'YYYY/MM/DD HH:mm:ss';
    }
    else {
        defaultFormat = options.format || 'YYYY-MM-DD HH:mm:ss';
    }

    value = value?.replaceAll('T',' ')?.replaceAll('Z', '');

    if (value && dayjs(value).isValid()){
        if(typeof value === 'number') value = unixToDate(value);
        if(options.utc){
            return dayjs(value).utc().format(defaultFormat);
        }
        return dayjs(value).add(dayjs().tz(timezone).utcOffset(), 'minutes').format(defaultFormat);
    }else{
        return defaultValue;
    }
}

export function unixToDate(timeStamp, utc = false) {
    // if(timeStamp) return new Date(timeStamp * 1000).toUTCString();
    // return defaultValue;
    if(timeStamp) return dayjs.unix(timeStamp).utc(utc);

    return defaultValue;
}

export function cleanString(value){
    if(!value || typeof value !== 'string') return "";
    return value.replace(/_/g, " ").replace(/-/g, " ").replace(/\./g, " ");
}

export function formatCell(value, formatter){
    if(formatter){
        switch (formatter){
            case 'toLocalTime':
                return toLocalTime(value);
            case 'titleFilter':
                return titleFilter(value);
            case 'capitalize':
                return capitalize(value);
        }
    } else{
        return value;
    }
}